module.exports = __webpack_public_path__ + "static/img/1_1_3_1.50838093.jpg";